export const LOGIN_REDIRECT_QUERY = "redirect"

export function getValidRedirectPath(redirect: unknown): string | null {
	if (typeof redirect !== "string" || !redirect) {
		return null
	}

	if (!redirect.startsWith("/") || redirect.startsWith("//") || redirect.includes("://")) {
		return null
	}

	if (redirect === "/login" || redirect.startsWith("/login?") || redirect.startsWith("/login/")) {
		return null
	}

	return redirect
}

export function getPostLoginPath(redirect: unknown, defaultPath: string): string {
	return getValidRedirectPath(redirect) ?? defaultPath
}
